<template>
  <b-row>
    <b-col sm="12" lg="12" style="padding: 0">
      <b-card class="mb-4 payment-gateways-card">
        <b-card-body class="p-0">
          <div class="container">
            <div class="row mb-3">
              <div class="col-md-6">
                <span style="font-weight: semi-bold; font-size: 20pt">{{ __('Payment Gateways') }}</span>
              </div>
            </div>

            <!-- Billplz accordion -->
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-2">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle="'accordion-billplz'"
                    variant="outline-primary"
                    class="accordion-subscription d-flex align-items-center justify-content-between"
                  >
                    <span class="product-name"
                      >Billplz
                      <span v-if="billplzSetting.enabled" class="text-white ml-2 badge badge-pill badge-success"
                        >Enabled</span
                      >
                      <span v-if="!billplzSetting.enabled" class="text-white ml-2 badge badge-pill badge-danger"
                        >Disabled</span
                      >
                    </span>

                    <span class="accordion-arrow-wrapper">
                      <i class="accordion-arrow"></i>
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-billplz"
                  accordion="my-accordion"
                  role="tabpanel"
                  @show="activeAccordion = 'billplz'"
                  @hide="activeAccordion = ''"
                >
                  <b-card-body class="billplz-card-body">
                    <b-card-text>
                      <!-- Billplz Settings Form -->
                      <b-form @submit.prevent="saveBillplzSettings" v-if="!fetching">
                        <b-form-group :label="__('Activate')">
                          <b-form-checkbox v-model="billplzSetting.enabled"></b-form-checkbox>
                        </b-form-group>

                        <b-form-group :label="__('Sandbox Mode')">
                          <b-form-checkbox v-model="billplzSetting.settings.testMode"></b-form-checkbox>
                        </b-form-group>

                        <b-form-group :label="__('Collection ID')">
                          <b-form-input
                            class="form-control"
                            v-model="billplzSetting.settings.collectionId"
                            :placeholder="__('Enter collection ID...')"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group :label="__('API Key')">
                          <b-form-input
                            class="form-control"
                            v-model="billplzSetting.settings.apiKey"
                            :placeholder="__('Enter API Key...')"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group :label="__('XSignature Key')">
                          <b-form-input
                            class="form-control"
                            v-model="billplzSetting.settings.xsignatureKey"
                            :placeholder="__('Enter XSignature key...')"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group class="text-center mt-4">
                          <b-button type="submit" variant="primary" :disabled="processing">
                            <b-spinner variant="light" small v-if="processing"></b-spinner>
                            <span>{{ __('Save') }}</span>
                          </b-button>
                        </b-form-group>
                      </b-form>

                      <b-alert :variant="billplzSuccess ? 'success' : 'danger'" v-if="billplzMessage" show>
                        {{ billplzMessage }}
                      </b-alert>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <!-- Chip -->
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-2">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle="'accordion-chip'"
                    variant="outline-primary"
                    class="accordion-subscription d-flex align-items-center justify-content-between"
                  >
                    <span class="product-name"
                      >CHIP
                      <span v-if="chipSetting.enabled" class="text-white ml-2 badge badge-pill badge-success"
                        >Enabled</span
                      >
                      <span v-if="!chipSetting.enabled" class="text-white ml-2 badge badge-pill badge-danger"
                        >Disabled</span
                      >
                    </span>

                    <span class="accordion-arrow-wrapper">
                      <i class="accordion-arrow"></i>
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-chip" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="chip-card-body">
                    <b-card-text>
                      <!-- Chip Settings Form -->
                      <b-form @submit.prevent="saveChipSettings" v-if="!fetching">
                        <b-form-group :label="__('Activate')">
                          <b-form-checkbox v-model="chipSetting.enabled"></b-form-checkbox>
                        </b-form-group>

                        <b-form-group :label="__('Mode')">
                          <b-select
                            :options="[
                              { text: 'Test', value: 'test' },
                              { text: 'Live', value: 'live' },
                            ]"
                            v-model="chipSetting.settings.mode"
                            :placeholder="__('Select Mode...')"
                          >
                          </b-select>
                        </b-form-group>

                        <!-- Test Mode Settings -->
                        <div v-if="chipSetting.settings && chipSetting.settings.mode === 'test'" class="mt-4">
                          <h4>{{ __('Test Mode Settings') }}</h4>

                          <b-form-group :label="__('Brand ID')">
                            <b-form-input
                              class="form-control"
                              v-model="chipSetting.settings.test.brandId"
                              :placeholder="__('Enter Brand ID...')"
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group :label="__('API Key')">
                            <b-form-input
                              class="form-control"
                              v-model="chipSetting.settings.test.apiKey"
                              :placeholder="__('Enter API Key...')"
                            ></b-form-input>
                          </b-form-group>
                        </div>

                        <!-- Live Mode Settings -->
                        <div v-if="chipSetting.settings && chipSetting.settings.mode === 'live'" class="mt-4">
                          <h4>{{ __('Live Mode Settings') }}</h4>

                          <b-form-group :label="__('Brand ID')">
                            <b-form-input
                              class="form-control"
                              v-model="chipSetting.settings.live.brandId"
                              :placeholder="__('Enter Brand ID...')"
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group :label="__('API Key')">
                            <b-form-input
                              class="form-control"
                              v-model="chipSetting.settings.live.apiKey"
                              :placeholder="__('Enter API Key...')"
                            ></b-form-input>
                          </b-form-group>
                        </div>

                        <b-form-group class="text-center mt-4">
                          <b-button type="submit" variant="primary" :disabled="processing">
                            <b-spinner variant="light" small v-if="processing"></b-spinner>
                            <span>{{ __('Save') }}</span>
                          </b-button>
                        </b-form-group>
                      </b-form>

                      <b-alert :variant="chipSuccess ? 'success' : 'danger'" v-if="chipMessage" show>
                        {{ chipMessage }}
                      </b-alert>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <!-- PayPal -->
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-2">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle="'accordion-paypal'"
                    variant="outline-primary"
                    class="accordion-subscription d-flex align-items-center justify-content-between"
                  >
                    <span class="product-name"
                      >PayPal
                      <span v-if="paypalSetting.enabled" class="text-white ml-2 badge badge-pill badge-success"
                        >Enabled</span
                      >
                      <span v-if="!paypalSetting.enabled" class="text-white ml-2 badge badge-pill badge-danger"
                        >Disabled</span
                      >
                    </span>
                    <span class="accordion-arrow-wrapper">
                      <i class="accordion-arrow"></i>
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-paypal" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="paypal-card-body">
                    <b-card-text>
                      <b-form @submit.prevent="savePaypalSettings" v-if="!fetching">
                        <b-form-group :label="__('Activate')">
                          <b-form-checkbox v-model="paypalSetting.enabled"></b-form-checkbox>
                        </b-form-group>

                        <b-form-group :label="__('Mode')">
                          <b-select
                            :options="[
                              { text: 'Sandbox', value: 'sandbox' },
                              { text: 'Live', value: 'live' },
                            ]"
                            v-model="paypalSetting.settings.mode"
                            :placeholder="__('Select Mode...')"
                          >
                          </b-select>
                        </b-form-group>

                        <b-form-group
                          v-if="paypalSetting.settings && paypalSetting.settings.mode === 'sandbox'"
                          class="mt-4"
                        >
                          <h4>{{ __('Test Mode Settings') }}</h4>

                          <b-form-group :label="__('App ID')">
                            <b-form-input
                              class="form-control"
                              v-model="paypalSetting.settings.sandbox.app_id"
                              :placeholder="__('Enter app ID...')"
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group :label="__('Client ID')">
                            <b-form-input
                              class="form-control"
                              v-model="paypalSetting.settings.sandbox.client_id"
                              :placeholder="__('Enter client ID...')"
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group :label="__('Client Secret')">
                            <b-form-input
                              class="form-control"
                              v-model="paypalSetting.settings.sandbox.client_secret"
                              :placeholder="__('Enter client secret key...')"
                            ></b-form-input>
                          </b-form-group>
                        </b-form-group>

                        <b-form-group
                          v-if="paypalSetting.settings && paypalSetting.settings.mode === 'live'"
                          class="mt-4"
                        >
                          <h4>{{ __('Live Mode Settings') }}</h4>

                          <b-form-group :label="__('App ID')">
                            <b-form-input
                              class="form-control"
                              v-model="paypalSetting.settings.live.app_id"
                              :placeholder="__('Enter app ID...')"
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group :label="__('Client ID')">
                            <b-form-input
                              class="form-control"
                              v-model="paypalSetting.settings.live.client_id"
                              :placeholder="__('Enter client ID...')"
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group :label="__('Client Secret')">
                            <b-form-input
                              class="form-control"
                              v-model="paypalSetting.settings.live.client_secret"
                              :placeholder="__('Enter client secret key...')"
                            ></b-form-input>
                          </b-form-group>
                        </b-form-group>

                        <b-form-group class="text-center mt-4">
                          <b-button type="submit" variant="primary">
                            <b-spinner variant="light" small v-if="false"></b-spinner>
                            <span>{{ __('Save') }}</span>
                          </b-button>
                        </b-form-group>
                      </b-form>

                      <b-alert :variant="paypalSuccess ? 'success' : 'danger'" v-if="paypalMessage" show>
                        {{ paypalMessage }}
                      </b-alert>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <!-- ToyyibPay -->
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-2">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle="'accordion-toyyibpay'"
                    variant="outline-primary"
                    class="accordion-subscription d-flex align-items-center justify-content-between"
                  >
                    <span class="product-name"
                      >ToyyibPay
                      <span v-if="toyyibpaySetting.enabled" class="text-white ml-2 badge badge-pill badge-success"
                        >Enabled</span
                      >
                      <span v-if="!toyyibpaySetting.enabled" class="text-white ml-2 badge badge-pill badge-danger"
                        >Disabled</span
                      >
                    </span>
                    <span class="accordion-arrow-wrapper">
                      <i class="accordion-arrow"></i>
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-toyyibpay" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="toyyibpay-card-body">
                    <b-card-text>
                      <!-- ToyyibPay Settings Form -->
                      <b-form @submit.prevent="saveToyyibpaySettings" v-if="!fetching">
                        <b-form-group :label="__('Activate')">
                          <b-form-checkbox v-model="toyyibpaySetting.enabled"></b-form-checkbox>
                        </b-form-group>

                        <b-form-group :label="__('Sandbox Mode')">
                          <b-form-checkbox v-model="toyyibpaySetting.settings.testMode"></b-form-checkbox>
                        </b-form-group>

                        <b-form-group :label="__('Category Code')">
                          <b-form-input
                            class="form-control"
                            v-model="toyyibpaySetting.settings.categoryCode"
                            :placeholder="__('Enter category code...')"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group :label="__('API Key')">
                          <b-form-input
                            class="form-control"
                            v-model="toyyibpaySetting.settings.apiKey"
                            :placeholder="__('Enter API Key...')"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group class="text-center mt-4">
                          <b-button type="submit" variant="primary" :disabled="processing">
                            <b-spinner variant="light" small v-if="processing"></b-spinner>
                            <span>{{ __('Save') }}</span>
                          </b-button>
                        </b-form-group>
                      </b-form>

                      <b-alert :variant="toyyibpaySuccess ? 'success' : 'danger'" v-if="toyyibpayMessage" show>
                        {{ toyyibpayMessage }}
                      </b-alert>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import toyyibpay from '../toyyibpay';

export default {
  name: 'PaymentGatewaysTab',
  components: { FontAwesomeIcon },
  props: ['manager'],

  data() {
    return {
      activeAccordion: '',
      fetching: false,
      success: false,
      message: '',
      setting: {
        enabled: false,
      },
      processing: false,
      billplzSetting: { enabled: false, settings: {}, testMode: false },
      chipSetting: {
        enabled: false,
        settings: {},
        mode: 'test',
        test: {
          brandId: '',
          apiKey: '',
        },
        live: {
          brandId: '',
          apiKey: '',
        },
      },
      paypalSetting: { enabled: false, settings: {}, mode: 'sandbox' },
      toyyibpaySetting: { enabled: false, settings: {}, testMode: false },
      chipMessage: '',
      chipSuccess: false,
      billplzMessage: '',
      billplzSuccess: false,
      paypalMessage: '',
      paypalSuccess: false,
    };
  },

  beforeMount() {
    this.fetchChipSetting();
    this.fetchBillplzSetting();
    this.fetchPaypalSetting();
    this.fetchToyyibpaySetting();
  },

  methods: {
    fetchChipSetting() {
      this.fetching = true;
      axios
        .get('/api/payment_gateways/showByName/chip')
        .then(({ data: { data: setting } }) => {
          this.chipSetting = { ...setting, enabled: setting.enabled == 1 };
        })
        .catch((error) => {
          this.showErrorNotification(this, [error], __('Failed'));
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    saveChipSettings() {
      this.fetching = true;
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          let postData = {
            _method: 'put',
            enabled: this.chipSetting.enabled == 1,
            ...this.chipSetting,
          };
          axios
            .post(`/api/payment_gateways/${this.chipSetting.id}`, postData)
            .then(({ data: { message, success } }) => {
              this.chipMessage = message;
              this.chipSuccess = success;
            })
            .catch((error) => {
              this.chipMessage = this.__('Failed');
              this.chipSuccess = false;
            });
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    fetchBillplzSetting() {
      this.fetching = true;
      axios
        .get('/api/payment_gateways/showByName/billplz')
        .then(({ data: { data: setting } }) => {
          this.billplzSetting = { ...setting, enabled: setting.enabled == 1 };
        })
        .catch((error) => {
          this.billplzMessage = this.__('Failed');
          this.billplzSuccess = false;
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    saveBillplzSettings() {
      this.fetching = true;
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          let postData = {
            _method: 'put',
            enabled: this.billplzSetting.enabled == 1,
            ...this.billplzSetting,
          };
          axios
            .post(`/api/payment_gateways/${this.billplzSetting.id}`, postData)
            .then(({ data: { message, success } }) => {
              this.billplzMessage = message;
              this.billplzSuccess = success;
            })
            .catch((error) => {
              this.billplzMessage = this.__('Failed');
              this.billplzSuccess = false;
            });
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    fetchPaypalSetting() {
      this.fetching = true;
      axios
        .get('/api/payment_gateways/showByName/paypal')
        .then(({ data: { data: setting } }) => {
          this.paypalSetting = { ...setting, enabled: setting.enabled == 1 };
        })
        .catch((error) => {
          this.paypalMessage = this.__('Failed');
          this.paypalSuccess = false;
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    savePaypalSettings() {
      this.fetching = true;
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          let postData = {
            _method: 'put',
            enabled: this.paypalSetting.enabled == 1,
            ...this.paypalSetting,
          };
          axios
            .post(`/api/payment_gateways/${this.paypalSetting.id}`, postData)
            .then(({ data: { message, success } }) => {
              this.paypalMessage = message;
              this.paypalSuccess = success;
            })
            .catch((error) => {
              this.paypalMessage = this.__('Failed');
              this.paypalSuccess = false;
            });
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    fetchToyyibpaySetting() {
      this.fetching = true;
      axios
        .get('/api/payment_gateways/showByName/toyyibpay')
        .then(({ data: { data: setting } }) => {
          this.toyyibpaySetting = {
            ...setting,
            enabled: setting.enabled == 1,
          };
        })
        .catch((error) => {
          this.showErrorNotification(this, [error], __('Failed'));
        })
        .finally(() => {
          this.fetching = false;
        });
    },

    saveToyyibpaySettings() {
      this.fetching = true;
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          let postData = {
            _method: 'put',
            enabled: this.toyyibpaySetting.enabled == 1,
            ...this.toyyibpaySetting,
          };
          axios
            .post(`/api/payment_gateways/${this.toyyibpaySetting.id}`, postData)
            .then(({ data: { message, success } }) => {
              this.toyyibpayMessage = message;
              this.toyyibpaySuccess = success;
            })
            .catch((error) => {
              this.toyyibpayMessage = this.__('Failed');
              this.toyyibpaySuccess = false;
            });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
  },
};
</script>

<style>
/* Arrow wrapper to ensure consistent positioning */
.accordion-arrow-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #3f51b5;
  transition: all 0.3s ease;
}

.accordion-invoice:not(.collapsed) .accordion-arrow-wrapper {
  background-color: rgb(0 123 255 / 29%);
  transform: rotate(180deg);
}

/* Improved arrow styling */
.accordion-arrow {
  display: block;
  width: 8px;
  height: 8px;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  transform: rotate(45deg) translateY(-2px);
  transition: transform 0.3s ease;
  margin-right: 2px;
}

/* Animation for the arrow */
.accordion-invoice:not(.collapsed) .accordion-arrow {
  transform: rotate(45deg) translateY(2px);
  margin-right: -2px;
  margin-top: -5px;
}

.billplz-card-body,
.chip-card-body,
.paypal-card-body,
.toyyibpay-card-body {
  padding: 40px;
}
</style>
